import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { VehiclePosition } from '../_models/vehiclePosition';
import { Vehicle } from '../_models/vehicle';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getLastPosition(vehicleId: number): Observable<VehiclePosition> {
    return this.http.get<VehiclePosition>(this.baseUrl + 'maps/' + vehicleId);
  }

  getLastPositionByImei(imei: string): Observable<VehiclePosition> {
    return this.http.get<VehiclePosition>(this.baseUrl + 'maps/lastPositionByImei/' + imei);
  }

  getVehicles(date: Date): Observable<Vehicle[]> {
    return this.http.get<Vehicle[]>(this.baseUrl + 'maps/vehicles/' + new Date(date).toJSON());
  }

  getPositions(date: Date, imei: string): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + 'maps/positions/' + new Date(date).toJSON() + '/' + imei);
  }

  getFromToPositions({ dateFrom, dateTo, imei, minVelocity }): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + `maps/positions`, {
      params: {
        searchOptions: JSON.stringify({
          dayFrom: dateFrom,
          dayTo: dateTo,
          imei,
          minVelocity
        })
      }
    });
  }

  getVehiclePositions(clientId: number): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + 'maps/vehiclePositions/' + clientId);
  }

  getVehiclePositions_NEW({ clientId, userId }): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + `maps/vehiclePositions/${clientId}/users/${userId}`);
  }

  getSharedPositionClientsData() {
    return this.http.get<any>(this.baseUrl + `maps/sharedPositions/data/clients`);
  }

  getSharedPositionVehiclesData() {
    return this.http.get<any>(this.baseUrl + `maps/sharedPositions/data/vehicles`);
  }

  getSharedPositionByVehicleId({ clientId, vehicleId, email }) {
    return this.http.get<VehiclePosition>(this.baseUrl + `maps/vehicles/${vehicleId}/sharedPosition`, {
      params: {
        searchOptions: JSON.stringify({ clientId, vehicleId, email })
      }
    });
  }

  getVehiclePositionsOSM(clientId: number): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + 'maps/vehiclePositionsOSM/' + clientId);
  }

  getVehiclePositionsOSM_NEW({ clientId, userId }): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + `maps/vehiclePositionsOSM/${clientId}/users/${userId}`);
  }

  getGroupVehiclePositions(clientId: number, groupId: number): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + 'maps/vehicleGroupPositions/' + clientId + '/' + groupId);
  }

  getVehicleGroupPositions_NEW({ clientId, groupId, userId }): Observable<VehiclePosition[]> {
    // this will be deleted
    return this.http.get<VehiclePosition[]>(this.baseUrl + `maps/vehicleGroupPositions/${clientId}/${groupId}/users/${userId}`);
  }

  getPosiionWithAddress(modemType: number, imei: string): Observable<VehiclePosition> {
    return this.http.get<VehiclePosition>(this.baseUrl + 'maps/positionWithAddress/' + modemType + '/' + imei);
  }

  getPositionAddresses(positions: any[], fromIndex: number): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'maps/positions/addresses/' + fromIndex, positions);
  }

  getLogGreska(imei: string): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'maps/log/greska/' + imei);
  }

  getLogSpisak(imei: string): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'maps/log/spisak/' + imei);
  }
  getLogsGreske(imei: string, number: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'maps/logs/greske/' + imei + '/' + number);
  }

  getLogsSpiskovi(imei: string, number: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'maps/logs/spiskovi/' + imei + '/' + number);
  }

  getAllVehiclePositions(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'maps/allVehiclePositions');
  }

  getAddressFromHereApi({ longitude, latitude }): Observable<any> {
    const url = `https://revgeocode.search.hereapi.com/v1/revgeocode?at=${longitude}%2C${latitude}&lang=sr-Latn-CS&apiKey=tHMdcYbXoZ_0P2ag0SB-OLwDmaeE5Un9r8HLXnf5k3I`;
    return this.http.get<any>(url);
  }


  private cache = new Map<string, any>();

  getAddressFromGeoapify({ lat, lon }){
    const url = `https://api.geoapify.com/v1/geocode/reverse?lat=${lat}&lon=${lon}&apiKey=48fc4a70434e4c2c90b779101a2ee732`
    if (this.cache.has(url)) {
      return of(this.cache.get(url));
    } 
    else {
      return this.http.get<any>(url).pipe(
        map(response => {
          // Cache the response
          this.cache.set(url, response);
          return response;
        }),
        catchError(error => {
          console.error('Error fetching data:', error);
          throw error;
        })
      );
    }
  }

  getDistanceFromGeoapify(locationDistance) {
    const url = `https://api.geoapify.com/v1/routematrix?apiKey=48fc4a70434e4c2c90b779101a2ee732`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
   
    return this.http.post<any>(url, locationDistance, {headers});
  }

  getLastPositionImei(imei: string): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'maps/lastPosition/' + imei);
  }
  // getModemParams(imei: string): Observable<any>  {
  //   return this.http.get<any>(this.baseUrl + 'maps/modem-parameter-show/'+imei);
  // }

  getSharedPositionsByCLientId({ clientId, filter }) {
    return this.http.get<any[]>(this.baseUrl + `maps/clients/${clientId}/sharedPositions`, {
      params: {
        searchOptions: JSON.stringify(filter)
      }
    });
  }

  deleteSharedPositionByFilter({ clientId, filter }) {
    return this.http.delete<void>(this.baseUrl + `maps/clients/${clientId}/sharedPositions`, {
      params: {
        searchOptions: JSON.stringify(filter)
      }
    });     
  }

  createSharedPositionByClientId({ clientId, input }) {
    return this.http.post<void>(this.baseUrl + `maps/clients/${clientId}/sharedPositions`, input);
  }

  updateSharedPositionByClientId({ clientId, input }) {
    return this.http.put<void>(this.baseUrl + `maps/clients/${clientId}/sharedPositions`, input);
  }
  getVehiclePositions_NEW_V2({ clientId, userId }): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + `maps/vehiclePositionsNewV2/${clientId}/users/${userId}`);
  }
  getVehiclePositionsOSM_NEW_V2({ clientId, userId }): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + `maps/vehiclePositionsOSMNewV2/${clientId}/users/${userId}`);
  }
  getVehicleGroupPositions_NEW_V2({ clientId, groupId, userId }): Observable<VehiclePosition[]> {
    // this will be deleted
    return this.http.get<VehiclePosition[]>(this.baseUrl + `maps/vehicleGroupPositionsNewV2/${clientId}/${groupId}/users/${userId}`);
  }

  getVehicleGroupPositions_NEW_V2_AdminTest({ clientId, userId }) {
    return this.http.get<any>(this.baseUrl + `maps/test111/${clientId}/users/${userId}/adminTest`);
  }
}
